"use strict";var e=require('./../ext/@artsy/fresnel/dist/index.js').__require();exports.distExports=e;
//# sourceMappingURL=index2.js.map
